import { useEffect } from 'react'
// import Image from 'components/image/image'
import Meta from 'components/meta/meta'
import useAppState from 'utils/state'
// import styles from 'styles/page/parduotuve.module.scss'
import { getData } from 'utils/api'
import { trackViewAccount } from 'utils/analytics/events'
import ProductsAccount from 'components/hits/products-account'
// import Heading from 'components/heading/heading'
// import Rating from 'components/rating/rating'
// import addKeywords from 'utils/keywords'
// import FeatureIcons from 'components/feature-icons/feature-icons'
// import { cn } from 'utils/helpers'

export default function Page(account) {
    const { visitorId } = useAppState()

    useEffect(() => {
        if (visitorId) {
            trackViewAccount(account)
        }
    }, [visitorId])

    return (
        <>
            <Meta title={account.name} description={account.short_description} image={account.seo_image} />
            {/*
            <div className={styles.img}>
                <div className={styles.imgCenter}>
                    <Image
                        src={account.image ? account.image : '/img/default-logo.png'}
                        alt={account.name}
                        layout="responsive"
                        objectFit="contain"
                        width="180"
                        height="180"
                    />
                </div>
            </div>
            */}
            <ProductsAccount hideRating brand={account.brand} account={account} />
        </>
    )
}

export async function getServerSideProps(context) {
    const brand = typeof context.query.b != 'undefined' ? `/${context.query.b}` : ''
    return getData(`store/${context.params.slug}${brand}`, true)
}
